// HomeHeaderContainer.jsx
import { useNavigate } from "react-router-dom";
import myrisIcon from '../../../assets/myris-tech-icon.png';
import './HomeHeaderContainer.css';

const HomeHeaderContainer = ({ showLoginButton = true, showSignupButton = true }) => {
  const navigate = useNavigate();

  return (
    <header className="header-component">
    {/* DESKTOP & TABLET */}
    <div className="header-desktop">
      <div onClick={() => navigate("/")} className="left-components" style={{ cursor: 'pointer' }}>
      <img src={myrisIcon} alt="Myris Tech" style={{ height: '50px', filter: "invert(1)" }}/>
      <h1>MYRIS TECH</h1>
      </div>  
      <div className="right-components">
      {showLoginButton && (
        <button onClick={() => navigate("/login")} className="button">
          <h1 style={{ margin: 5 }}>Login</h1>
        </button>
      )}
      </div>
      
      <div className="left-components">
      {showSignupButton && (
        <button onClick={() => navigate("/signup")} className="button">
          <h1 style={{ margin: 5 }}>Signup</h1>
        </button>
      )}
      </div>
    </div>

    {/* MOBILE */}
    <details className="header-ribbon">
      <summary className="ribbon-bar">
      <div className="ribbon-left" onClick={() => navigate("/")} role="button" tabIndex={0}>
        <img src={myrisIcon} alt="Myris Tech" className="logo-sm"/>
        <h1 className="brand-sm">MYRIS TECH</h1>
      </div>
      {showLoginButton && (
      <span className="hamburger" aria-hidden>☰</span>
      )}
      </summary>
      <nav className="ribbon-menu" aria-label="Mobile">
      {showLoginButton && (
        <button className="ribbon-card"
          onClick={() => { navigate("/login"); document.querySelector(".header-ribbon")?.removeAttribute("open"); }}>
          Login
        </button>
      )}
      {showSignupButton && (
        <button className="ribbon-card"
          onClick={() => { navigate("/signup"); document.querySelector(".header-ribbon")?.removeAttribute("open"); }}>
          Signup
        </button>
      )}  
      <button className="ribbon-card" type="button" style={{ marginBottom: '5px' }}
        onClick={(e)=> e.currentTarget.closest('details')?.removeAttribute('open')}
        aria-label="Close menu">Close Menu</button>
      </nav>
    </details>
    </header>
  );
};

export default HomeHeaderContainer;